export const ROUTES = {
  splash: '/',
  login: '/login',
  kyc: '/kyc',
  home: '/home',
  loanApply: '/loan/apply',
  loanConfirm: '/loan/confirm',
  loanSuccess: '/loan/success',
  loansList: '/loans',
  loanDetail: '/loans/:id',
  score: '/score',
  repay: '/repay',
  profile: '/profile',
  settings: '/settings',
} as const;

export type Route = (typeof ROUTES)[keyof typeof ROUTES];

export const loanDetailPath = (id: string) => `/loans/${id}`;
